import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// project import
import useAuth from "hooks/useAuth";

// types
import { GuardProps } from "types/auth";
import { dispatch } from "store";
import { openSnackbar } from "store/reducers/snackbar";

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, twoFactorAuth, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("login", {
        state: {
          from: location.pathname,
        },
        replace: true,
      });
    } else {
      if (user && !user.two_factor_enabled) {
        if (location.state) {
          dispatch(
            openSnackbar({
              open: true,
              message: "Please Configure 2FA first",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        }
        navigate("/my-profile?tab=configure-2fa", {
          state: {
            from: location.pathname,
          },
        });
      }
    }
  }, [isLoggedIn]);

  return children;
};

export default AuthGuard;
